export default "---\ntitle: Purchase a Shipping Label\n---\n\n## Coming Soon\n"